module.exports = __webpack_public_path__ + "static/media/biz-collage.07b03ed7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biz-collage.jpg
// module id = 1588
// module chunks = 0